import { themeContext } from '@azgaz/azgaz-ui';
import { config } from '@/utils';
import appCreator from '../appCreator';
import * as components from './components';
import { getFiltersConfig } from './filtersConfig';

const dealerApp = async () => {
  const { dealerExternalId } = config.all();

  const filtersConfig = getFiltersConfig();

  // Пробуем определить id дилера по dealer_external_id
  if (dealerExternalId) {
    try {
      const response = await fetch(
        `${config.get(
          'carstockApi'
        )}dealers/?app_metadata.dealer_external_id=${dealerExternalId}`
      );

      const dealers = await response.json();
      const dealerId = dealers[0]?.id;

      if (dealerId) {
        filtersConfig.dealerIn.defaultVal = [dealerId];
      } else {
        throw new Error(
          'Не удалось определить id дилера по dealer_external_id'
        );
      }
    } catch (e) {
      console.error(e);
    }
  }

  return appCreator({
    filtersConfig,
    azgazUiTheme: themeContext.rusbusTheme,
    components,
  });
};

export default dealerApp;
